<ng-container *ngIf="isBannerSelected() === true">
   <p [innerHTML]="bannerNote"></p>
</ng-container>
